exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".step2.step2active .checkbox .jq-checkbox.checked:after{width:5px;height:12px;left:4px}.step2.step2active .checkbox input#check2{position:absolute;z-index:-1;opacity:0;padding:0}.step2.step2active .error{padding:13px 50px 13px 15px;border-radius:5px;border:1px solid #ecacb4;background:#f8dade;max-width:800px;margin:15px auto -45px;display:block;position:relative;margin-bottom:5px;text-align:left}.step2.step2active .error p{font-size:14px;color:#dd485b;line-height:1.2;max-width:100%;margin:0;margin-top:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!./components/verifications/disclaimer/disclaimer.css
// module id = 1089
// module chunks = 0